
"use client";

import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import ProductsGridAndFilters from '@/app/product/ProductsGridAndFilters';
import { useSearchParams } from 'next/navigation';

function ProductsContent() {
    const searchParams = useSearchParams();
    const initialCategory = searchParams.get('category') || undefined;
    const searchQuery = searchParams.get('q');

    // This component now just acts as a wrapper to get search params
    // and pass them to the main component. All logic is inside ProductsGridAndFilters.
    
    return (
        <ProductsGridAndFilters 
            initialCategory={initialCategory}
            searchQuery={searchQuery}
        />
    );
}


export default function ProductsPage() {
    return (
        <Suspense fallback={<div className="flex justify-center py-16"><Loader2 className="h-16 w-16 animate-spin" /></div>}>
            <ProductsContent />
        </Suspense>
    );
}
